import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useGetPopularEventsQuery } from '@/store/api/sportsApi';
import { useNavigate } from 'react-router-dom';
import { sportsIconMap } from '@/utils/constants';

const HeaderTopGames = () => {
  const navigate = useNavigate();
  const { data: popularEventsData } = useGetPopularEventsQuery();
  const events = popularEventsData?.events ?? [];

  return (
    <Swiper
      slidesPerView={2}
      spaceBetween={4}
      loop={true}
      className="w-full max-xl:px-[5px] xl:px-2 xl:hidden"
    >
      {events.map((event, index) => (
        <SwiperSlide key={index}>
          <div
            className="cursor-pointer h-[29px] bg-secondary flex items-center overflow-hidden"
            onClick={() => navigate(`/game-details/${event.sport}/${event.id}`)}
          >
            <div className="flex items-center px-[6px] gap-[14px] w-full min-w-0">
              <span className="text-white shrink-0">
                <img className="size-[14px] invert" src={sportsIconMap[event.sport] ?? ''} />
              </span>

              <span
                className={`
          flex-1 min-w-0
          text-white
          text-[14px]
          leading-[21px]
     font-bold
          overflow-hidden whitespace-nowrap animate-pulse-full text-ellipsis text-center
        `}
              >
                {event.name}
              </span>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HeaderTopGames;
